import {Observable, Subscription} from 'rxjs';

import IPlaybackStore from '../Interfaces/IPlaybackStore';

const subscribeToSeekToLiveEdgeTap = (
    seekToLiveEdgeTap$: Observable<void>,
    playbackStore: IPlaybackStore
): Subscription =>
    seekToLiveEdgeTap$
        .subscribe(() => playbackStore.actions.seekToLiveEdge());

export default subscribeToSeekToLiveEdgeTap;